<div class="modal-dialog">
  <div class="modal-body mb-6">
    <p class="flex items-center">
      <span>{{ message }}</span>
    </p>
  </div>
  <footer class="flex items-center justify-end mt-4 gap-4">
    <p-button type="button" styleClass="btn-contrast-workflow" (click)="save()">{{ saveLabel }}</p-button>
    <p-button type="button" styleClass="btn-outlined-dark btn-workflow !px-6 !py-[7px] h-[38px]" (click)="cancel()">{{ cancelLabel }}</p-button>
  </footer>
</div>
